import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "./authentication.service";
import { AgoraConfigService } from "src/AgoraConfigService";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    agoraConfigObject: any;

    constructor(private authenticationService: AuthenticationService, private agoraConfig: AgoraConfigService) {
		// this.agoraConfigObject = this.agoraConfig.getConfig().apiBaseUrl;
    
    
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to api url
        
        const currentUser = this.authenticationService.currentUserValue;
        const isLoggedIn = currentUser && currentUser.jwtToken;
        request = request.clone({
            setHeaders: {
                "Strict-Transport-Security": "max-age=31536000; includeSubdomains",
                "X-Frame-Options": "SAMEORIGIN",
                "X-Content-Type-Options": "nosniff",
                "X-Xss-Protection": "1; mode=block",
                "SameSite" : "strict",
                "Content-Security-Policy": "default-src 'self'; script-src 'self'  'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline';img-src 'self' http: data:;font-src 'self' https:; connect-src 'self' http:; object-src 'none'; frame-src 'self'; SameSite : strict; SameSite 'strict';",   
            }

        })
        const isApiUrl = request.url.startsWith(`${this.agoraConfig.getConfig().apiBaseUrl}`);
        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                 }
            });
            if(localStorage!=null && localStorage.getItem('encLoginName')!=undefined && localStorage.getItem('encLoginName')!=null){
                const encLoginName = localStorage.getItem('encLoginName');
                request = request.clone({
                    setHeaders: {
                        "userName": `${encLoginName}`
                    }
                });
            }

        }
        return next.handle(request);
    }
}
